import React,{useState} from "react";
import moment from "moment";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import { useHistory } from "react-router-dom";
import Select from "react-select";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Table,
  Row,
  Col
} from "reactstrap";
import axios from "axios";
import { FETCH_ALL_CREDITS,TRANSC_CREDIT } from "../../constants";

import NotificationAlert from "react-notification-alert";

let channels = [
  {
    value: "Select All",
    label: "Select All",

  },
  { value: "SMS", label: "SMS" },
  { value: "Whatsapp", label: "Whatsapp" },
  { value: "RCS", label: "RCS" },
  { value: "IVR", label: "IVR" },
  { value: "Email", label: "Email" },
];
const Credits = () => {

  const navigate = useHistory();

  const notificationAlertRef = React.useRef(null);
  const [isLoading, setIsLoading] = React.useState(true);


  const [pulseList, setPulseList] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  const[filterList,setFilterLst] = useState([]);





  React.useEffect(() => {
    viewPulseList(1);
    
  }, []);


  const viewPulseList = (pageNo) => {
    let lcObj = localStorage.getItem("user");
    let lclStrge = JSON.parse(lcObj);
    let clientid=lclStrge?.client;
    let user_id=lclStrge?.user_id;

    axios
      .get(`${FETCH_ALL_CREDITS}?page=${pageNo}&id=${clientid}&created_by=${user_id}`)
      .then((response) => {
        setPulseList(response.data);
       // setPulseList({...response.data,numOfPages:2});
        setFilterLst(response.data)
        setCurrentPage(pageNo);
        setIsLoading(false)
      })
      .catch((error) => {
        console.log("????", error);
        setIsLoading(false)
      });
  };



  const changelistbychnl=(chanl)=>{
    const data = filterList?.message?.filter(chnl => chnl.channel === chanl?.value)
    if(chanl?.value!=="Select All"){
      setPulseList({message:data})
    }else{
      setPulseList(filterList)
    }
    
  }
   

  return (
    <>
     <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
      <div className="content pd-0">
      {alert}
        <Row>
          <Card className="mb-0">
            <NotificationAlert ref={notificationAlertRef} />
            <CardBody>
              <Col sm="12">
                <Row>
                  <Col sm="9">
                    <h4 className="mt-4 add-content" onClick={()=>{
                          navigate.push("/admin/config/createCredits");
                        }}>
                      <Button
                        className="btn btn-icon btn-link-add btn-sm mr-2"
                        
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </Button> Add Credit
                    </h4>
                  </Col>
                  <Col sm="3" className="mt-4 add-content">
                  <Select
                    className="react-select info"
                    classNamePrefix="react-select"
                    placeholder="Select Channel"
                    name="channel"
                   // value={credits?.channel}
                    onChange={(value) => {
                    changelistbychnl(value)
                    }}
                    options={channels}
                  />
                  
                </Col>
                </Row>
              </Col>
              <Col sm="12" className="tableheightwf">
                <Row>
                  <Table responsive striped>
                    <thead>
                      <tr>
                      <th>S.no</th>
                       <th>Client</th>
                       <th>Channel</th>
                        <th>Amount</th>
                        <th>Pulse</th>
                        <th>Credits</th>
                        <th>T_Balance</th>
                        <th>T_Credits</th>
                        <th>Trans Type</th>
                        <th>Date</th>
                        {/* <th>Balance</th> */}

                      </tr>
                    </thead>
                    <tbody>
                      {pulseList?.message?.length>0?pulseList?.message?.map((item, index) => {
                 
                        
                         
                        return (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{++index}</td>
                              <td>{item.company_name}</td>
                              <td>{item.channel}</td>
                              <td>{item.price===0?" --":item.price}</td>
                              <td>{item.pulse===0?" --":item.pulse}</td>
                              <td>{item.credits===0?" --":item.credits}</td>
                              <td>{item.balance===0?" --":item.balance}</td>
                              <td>{item.total_credits===0?"--":item.total_credits}</td>

                              <td>{item.transaction_type===TRANSC_CREDIT?"CREDIT":"DEBIT"}</td>

                              
                              <td>{moment(item.created_at).format("DD-MM-YYYY HH:mm")}</td>
                           
                              
                            </tr>
                          </React.Fragment>
                        );
                      }) :
                      <tr>
                            <td colSpan={10}>No Records Found</td>
                          </tr>
                      }
                
                    </tbody>
                  </Table>
                </Row>
              </Col>
            </CardBody>
            { pulseList?.num_of_pages>1&&
        <div style={{padding:"8px",marginLeft:"auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={pulseList?.num_of_pages}
      onPageChange={(newPage )=>{viewPulseList(newPage)}}
    />
    </div>
}
          </Card>

         
         
        </Row>
      </div>
    </>
  );
};

export default Credits;
